module.exports = "https://ssr-releases-cdn.paperlesspost.com/_next/static/images/Block3_Mobile-39942e28063d0602ab114e66bf3a86e7.png";